<template>
	<div>
		<el-dialog title="报修详情" :visible.sync="show" width="40%">
			<det :row="row"></det>
			<el-divider></el-divider>
			<div v-if="row.status!='审核中'">
				<h3 style="margin-bottom: 10px;">客服处理</h3>
				<div>处理人 ：{{row.approvalName}}</div>
				<div style="margin:  10px 0;">处理时间 ：{{setTime(row.approvalTime)}}</div>
				<div>处理状态 ：{{row.status}}</div>
				<div style="margin:  10px 0;" v-if="row.result=='已确认'||row.result=='已完成'||row.result=='已支付'||row.result=='已填写'">
					<div>支付金额 ：{{row.price}}</div>
				</div>
				<div >支付状态 ：{{row.payment}}</div>
				<div v-if="row.result=='已完成'||row.result=='已完善'" style="margin-top:30px">
					<h3 style="margin-bottom: 10px;">工人服务</h3>
					<div>工人姓名 ：{{row.worker}}</div>
					<div style="margin:  10px 0;">工人手机号 :{{row.workerPhone}}</div>
				</div>
				<div v-if="row.result=='已完成'">
					<div>完成状态 ：{{row.result}}</div>
					<div style="margin:  10px 0;">完成时间 ：{{setTime(row.completeTime)}}</div>
				</div>
			</div>
			<div v-else>处理中</div>
		    <!--div v-if="row.status=='已同意'&&row.flag!=4">
				<h3 style="margin: 10px 0;">派单</h3>
				<el-select  v-model="user"  placeholder="选择工人" clearable="clearable">
					<el-option  v-for="item in users" :label="item.userName " :value="item.userId"></el-option>
				</el-select>
			</div>
			<span v-if="row.status=='已同意'&&row.flag!=4" slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="yes">确 定</el-button>
			</span>
		   <div v-if="row.status=='已同意'&&row.flag==4">
				<h3 style="margin: 10px 0;">已完成派单</h3>
				<div>被派单人员:{{row.dispatchName}}</div>
				<div>派单时间:{{setTime(row.dispatchTime)}}</div>
			</div>
			<el-input v-if="row.status" type="textArea" placeholder="如果拒绝,请填写拒绝原因" v-model="reason"></el-input>
			<span v-if="row.status" slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ok(1)">同 意</el-button>
				<el-button @click="ok(0)">拒 绝</el-button>
			</span> 
			</div-->
		</el-dialog>
		<el-dialog title="报修审核" :visible.sync="isCheck" width="40%">
			<det :row="row"></det>
			<el-divider></el-divider>
			<el-input v-if="row.status" type="textArea" placeholder="如果拒绝,请填写拒绝原因" v-model="reason"></el-input>
			<span v-if="row.status" slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ok(1)">同 意</el-button>
				<el-button @click="ok(0)">拒 绝</el-button>
				<el-button @click="closeCheck()">关 闭</el-button>
			</span> 
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="报修人">
				<el-input v-model="form.username" size="small" placeholder="报修人" clearable=""></el-input>
			</el-form-item>
      <el-form-item label="报修项目">
        <el-input size="small" v-model="form.repairItem" placeholder="报修项目" clearable=""></el-input>
    </el-form-item>
    <el-form-item label="报修日期" prop="queryDate">
      <el-date-picker clearable size="small" v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
      </el-date-picker>
  </el-form-item>

			<!-- <el-form-item label="处理状态">
				<el-select v-model="form.result" placeholder="处理状态" clearable="clearable">
					<el-option label="待接单" value="待接单"></el-option>
					<el-option label="处理中" value="处理中"></el-option>
					<el-option label="已确认" value="已确认"></el-option>
					<el-option label="已支付" value="已支付"></el-option>
				</el-select>
			</el-form-item> -->
			<!-- <el-form-item label="审核状态">
				<el-select v-model="form.status" placeholder="审核状态" clearable="clearable">
					<el-option label="已同意" value="已同意"></el-option>
					<el-option label="已拒绝" value="已拒绝"></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="username" label="报修人"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
			<el-table-column prop="area" label="故障区域">
				<template slot-scope="{row}">
					<span v-for="s in row.area">{{s+' '}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="projectName" label="报修项目"></el-table-column>
			<el-table-column prop="unitPrice" label="配件价格"></el-table-column>
			<el-table-column prop="labourCost" label="人工费"></el-table-column>
			<el-table-column prop="createTime" label="报修时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column prop="result" label="处理状态"></el-table-column>
			<el-table-column prop="status" label="审核状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">查看</el-button>
					<el-button type="text" v-if="row.status =='审核中'" @click="getCheckRow(row)">审核</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
	</div>
</template>

<script>
import det from "./det.vue";
export default {
  components: {
    det,
  },
  data() {
    return {
      roleId: sessionStorage.roleId,
      user: "", //派单选择的工人
      users: [],
      show: false,
      isCheck: false,
      data: [],
      reason: null,
      row: {},
      form: {
        result: "未完成",
        status: "", //
        username: "",
        repairItem: '',
        currentPage: 1,
        pageSize: 10,
      },
      totalNum: 0,
      queryDate: []
    };
  },
  methods: {
    getId(val) {
      console.log(val);
    },
    yes() {
      console.log(this.user);
      if (this.user == "") {
        this.$message.warning("请选择工人");
        return;
      }
      this.show = false;
      this.$http
        .post(`/api/bdRepairApply/dispatch`, {
          dispatch: this.user,
          processId: this.row.processId,
          id: this.row.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    ok(type) {
      this.isCheck = false;
      let params = {
        id: this.row.id,
        result: type == 1 ? "已同意" : "已拒绝",
        processId: this.row.processId,
        agree: type == 1,
        reason: this.reason,
      };
      this.$http
        .post(`/api/bdRepairApply/ApprovalRepairApply`, params)
        .then((res) => {
          console.log("res.data:", JSON.stringify(res.data));
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.getAll();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    closeCheck() {
      this.isCheck = false;
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    getRow(row) {
      console.log(row);
      // row.showPathList=JSON.parse(row.showPathList)
      this.row = row;
      this.show = true;
    },
    getCheckRow(row) {
      console.log(row);
      this.row = row;
      this.isCheck = true;
    },
    getAll() {
      console.log("查询条件：", JSON.stringify(this.form));
      if (this.queryDate && this.queryDate.length == 2) {
                this.form.repairTime = this.queryDate[0];
                this.form.finishTime = this.queryDate[1];
            } else {
                this.form.repairTime = null;
                this.form.finishTime = null;
            }
      this.$http
        .post(`/api/bdRepairApply/queryRepairApply`, this.form)
        .then((r) => {
          if (r.data.data != null) {
            this.data = r.data.data.items;
            this.totalNum = r.data.data.totalNum;
          } else {
            this.data = null;
            this.totalNum = 0;
          }
        });
    },
    getUsers() {
      this.$http.get(`/api/bdRepairApply/getDispatch`).then((r) => {
        this.users = r.data.data;
      });
    },
  },
  mounted() {
    this.getAll();
    this.getUsers();
  },
};
</script>

<style>
</style>
